import React from 'react';
import { useSelector } from 'react-redux';
import { Tabs, Typography } from 'antd';
import UserOverviewTab from '../UserOverviewTab/UserOverviewTab';
import ActiveProjectsTreeTable from '../Table/ActiveProjectsTreeTable';
import InactiveProjectsTreeTable from '../Table/InactiveProjectsTreeTable';
import ActivitiesTable from '../Table/ActivitiesTable';
import UserNotes from '../UserNotes/UserNotes';
import UserClaimsTable from '../Table/UserClaimsTable';

const { TabPane } = Tabs;
const { Title } = Typography;

const UserTabs = () => {
  const currentUser = useSelector((state) => state.currentUser);

  function callback(key) {
    // console.log(key);
  }

  return (
    <>
      <Title
        level={3}
        style={{ marginBottom: '24px', marginTop: '0px', height: '36px' }}
      >
        {currentUser.name ? `${currentUser.name}` : ''}
      </Title>
      <Tabs onChange={callback} type="card">
        <TabPane tab="Informacje ogólne" key="1">
          <UserOverviewTab data={currentUser} />
        </TabPane>
        <TabPane tab="Wnioski" key="2">
          <UserClaimsTable userId={currentUser.id} />
        </TabPane>
        <TabPane tab="Aktualne Projekty" key="3">
          {/*  TODO status prop is unused*/}
          <ActiveProjectsTreeTable userId={currentUser.id} status="active" />
        </TabPane>
        <TabPane tab="Zarchiwizowane projekty" key="4">
          <InactiveProjectsTreeTable
            userId={currentUser.id}
            status="inactive"
          />
        </TabPane>
        <TabPane tab="Inne Aktywności" key="5">
          {/*  TODO status prop is unused*/}
          <ActivitiesTable userId={currentUser.id} status="active" />
        </TabPane>

        <TabPane tab="Notatki" key="6">
          <UserNotes
            style={{ marginTop: '1000px' }}
            notes={currentUser.userNotes}
            userId={currentUser.id}
          />
        </TabPane>
      </Tabs>
    </>
  );
};

export default UserTabs;
